var _rect, _path, _g, _path2, _g2, _rect2, _rect3, _rect4, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSieutIrregular = function SvgSieutIrregular(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 20,
    fill: "#F4F4F4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4527_2081",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 40,
    width: 53,
    height: 10
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2272 40.3628C21.7519 40.3628 10 43.1943 10 46.6825C10 47.5567 10.7374 48.3894 12.0663 49.1446C16.0585 46.8748 25.378 45.2825 36.2272 45.2825C47.0764 45.2825 56.3959 46.8748 60.3873 49.1446C61.7165 48.3894 62.454 47.5567 62.454 46.6825C62.454 43.1943 50.702 40.3628 36.2272 40.3628Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4527_2081)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2272 40.3628C21.7519 40.3628 10 43.1943 10 46.6825C10 47.5567 10.7374 48.3894 12.0663 49.1446C16.0585 46.8748 25.378 45.2825 36.2272 45.2825C47.0764 45.2825 56.3959 46.8748 60.3873 49.1446C61.7165 48.3894 62.454 47.5567 62.454 46.6825C62.454 43.1943 50.702 40.3628 36.2272 40.3628Z",
    fill: "url(#paint0_linear_4527_2081)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4527_2081",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 45,
    width: 49,
    height: 8
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0654 45.2847H60.3864V53.0002H12.0654V45.2847Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4527_2081)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0654 49.1431C16.0572 46.8752 25.3771 45.2847 36.2259 45.2847C47.0755 45.2847 56.3946 46.8752 60.3864 49.1431C56.3946 51.4124 47.0755 53.0003 36.2259 53.0003C25.3771 53.0003 16.0572 51.4124 12.0654 49.1431Z",
    fill: "#C8C8C8"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 8,
    width: 1,
    height: 9,
    rx: 0.5,
    fill: "#C4C4C4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 9,
    width: 1,
    height: 15,
    rx: 0.5,
    fill: "#C4C4C4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 9,
    width: 1,
    height: 11,
    rx: 0.5,
    fill: "#C4C4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8204 22.9165C39.0459 21.5544 38.1245 20.2673 36.7623 20.0418C35.4002 19.8162 34.1131 20.7377 33.8876 22.0998L33.0024 27.4461C32.9066 28.0249 32.5614 28.5325 32.0583 28.8344L22.5886 34.5162C21.4047 35.2265 21.0208 36.7622 21.7311 37.9461C22.4415 39.1301 23.9771 39.514 25.1611 38.8036L33.1353 34.0191C33.9758 33.5148 35.0579 33.694 35.6911 34.4423L41.6977 41.5415C42.5896 42.5955 44.167 42.727 45.2211 41.8352C46.2751 40.9434 46.4066 39.3659 45.5148 38.3119L38.3816 29.8813C38.0026 29.4334 37.8394 28.8416 37.9353 28.2628L38.8204 22.9165Z",
    fill: "#DF6D65"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8204 22.9165L38.3271 22.8349L38.8204 22.9165ZM33.8876 22.0998L33.3943 22.0182L33.8876 22.0998ZM22.5886 34.5162L22.3314 34.0874L22.3314 34.0874L22.5886 34.5162ZM21.7311 37.9461L21.3024 38.2034L21.3024 38.2034L21.7311 37.9461ZM25.1611 38.8036L24.9038 38.3749L24.9038 38.3749L25.1611 38.8036ZM41.6977 41.5415L42.0794 41.2185L41.6977 41.5415ZM45.2211 41.8352L45.544 42.2169L45.2211 41.8352ZM45.5148 38.3119L45.8965 37.9889L45.5148 38.3119ZM38.3816 29.8813L38.7633 29.5583L38.3816 29.8813ZM37.9353 28.2628L38.4286 28.3444L37.9353 28.2628ZM33.1353 34.0191L32.878 33.5904L33.1353 34.0191ZM33.0024 27.4461L33.4957 27.5277L33.0024 27.4461ZM32.0583 28.8344L31.801 28.4056L32.0583 28.8344ZM36.6807 20.535C37.7704 20.7155 38.5076 21.7451 38.3271 22.8349L39.3137 22.9982C39.5843 21.3636 38.4786 19.8191 36.844 19.5485L36.6807 20.535ZM34.3809 22.1815C34.5613 21.0918 35.5909 20.3546 36.6807 20.535L36.844 19.5485C35.2094 19.2778 33.6649 20.3836 33.3943 22.0182L34.3809 22.1815ZM33.4957 27.5277L34.3809 22.1815L33.3943 22.0182L32.5091 27.3644L33.4957 27.5277ZM22.8459 34.9449L32.3155 29.2631L31.801 28.4056L22.3314 34.0874L22.8459 34.9449ZM22.1599 37.6889C21.5916 36.7417 21.8987 35.5132 22.8459 34.9449L22.3314 34.0874C20.9106 34.9399 20.4499 36.7826 21.3024 38.2034L22.1599 37.6889ZM24.9038 38.3749C23.9567 38.9432 22.7282 38.6361 22.1599 37.6889L21.3024 38.2034C22.1548 39.6241 23.9976 40.0848 25.4183 39.2324L24.9038 38.3749ZM32.878 33.5904L24.9038 38.3749L25.4183 39.2324L33.3925 34.4479L32.878 33.5904ZM42.0794 41.2185L36.0728 34.1193L35.3094 34.7652L41.316 41.8645L42.0794 41.2185ZM44.8981 41.4535C44.0549 42.167 42.7929 42.0618 42.0794 41.2185L41.316 41.8645C42.3862 43.1293 44.2792 43.2871 45.544 42.2169L44.8981 41.4535ZM45.1331 38.6349C45.8465 39.4781 45.7413 40.7401 44.8981 41.4535L45.544 42.2169C46.8089 41.1467 46.9667 39.2538 45.8965 37.9889L45.1331 38.6349ZM37.9999 30.2043L45.1331 38.6349L45.8965 37.9889L38.7633 29.5583L37.9999 30.2043ZM38.3271 22.8349L37.442 28.1811L38.4286 28.3444L39.3137 22.9982L38.3271 22.8349ZM38.7633 29.5583C38.4791 29.2224 38.3567 28.7786 38.4286 28.3444L37.442 28.1811C37.3222 28.9047 37.5262 29.6444 37.9999 30.2043L38.7633 29.5583ZM33.3925 34.4479C34.0229 34.0696 34.8345 34.204 35.3094 34.7652L36.0728 34.1193C35.2814 33.184 33.9287 32.96 32.878 33.5904L33.3925 34.4479ZM32.5091 27.3644C32.4373 27.7985 32.1784 28.1792 31.801 28.4056L32.3155 29.2631C32.9444 28.8858 33.3759 28.2513 33.4957 27.5277L32.5091 27.3644Z",
    fill: "#DF6D65"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4527_2081",
    x1: 32.6402,
    y1: 51.4831,
    x2: 38.5844,
    y2: 32.5574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#606060"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSieutIrregular);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "apps/static/media/sieut-irregular.50dea072e4c2f64e349a165050fb071f.blank.svg";